import { render, staticRenderFns } from "./RegisterWidget.vue?vue&type=template&id=8cdeff66&scoped=true"
import script from "./RegisterWidget.vue?vue&type=script&lang=js"
export * from "./RegisterWidget.vue?vue&type=script&lang=js"
import style0 from "./RegisterWidget.vue?vue&type=style&index=0&id=8cdeff66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdeff66",
  null
  
)

export default component.exports